import React from 'react';
import { Link } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import InfoIcon from '@material-ui/icons/Info';

const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: "2px solid #00567a",
        borderRadius: "8px",
        boxShadow: theme.shadows[5],
        padding: "8px 16px 16px",
        maxHeight: `68vh`,
        width: '75vw',
        overflow: 'auto',
        outline: "none"
    },
}));

const ModalWidget = props => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const createMarkup = props => {
        return { __html: props };
    };

    const body = (
        <div 
            className={classes.paper}
        >
            <h3 id="simple-modal-title" className="margin-top-4" style={{color: props.color}}>{props.title}</h3>
            <div 
                id="simple-modal-description" 
                style={{fontSize: "1rem", wordBreak: 'break-word'}}
                dangerouslySetInnerHTML={createMarkup(
                    props.body
                )}
            />
            
            {typeof props.action !== 'undefined' && props.action === 'question'
                ? (
                    <div style={{
                        display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'
                    }} className="width100 padding-bottom-24 padding-top-8">
                        <div style={{
                            padding: "16px 12px",
                            borderRadius: "3px",
                            color: "rgb(0, 0, 0.9)",
                            backgroundImage: "linear-gradient(45deg, rgba(0, 0, 0, 0.08) 30%, rgba(0, 0, 0, 0.08) 90%)",
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex",
                            fontSize: "1.1em"
                        }}>
                            <Link 
                                to={{
                                    pathname: "/SingleQuestionScreen",
                                    questionid: props.questionid,
                                    gameMode: 5
                                }}
                                style={{
                                    color: "rgba(0,0,0.9)",
                                }}
                                onClick={() => {
                                    props.setPrevPageDetails()
                                }}
                            >
                                Answer Question
                            </Link>
                        </div>
                    </div>
                ) : null
            }

        </div>
    );

    return(
        <div>
            <button type="button" className="button-text" onClick={handleOpen} style={{color: props.color, padding: "0"}}>
                {props.text}
            </button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{
                    display:"flex",
                    flexDirection:"column",
                    justifyContent:"center",
                    alignItems:"center"
                }}
            >
                {body}
            </Modal>
        </div>
    )
}

export default ModalWidget;